import styled from "styled-components";
import {Product, StyledBaseProps} from "@betrue/shared/interfaces";
import React from "react";
import {ProjectProductListProps} from "@betrue/ui";
import {IconButton, List, ListItem, ListItemSecondaryAction, ListItemText} from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';

export interface ProjectProductListViewProps extends StyledBaseProps, ProjectProductListProps {
  productList: Product[],
  onDeleteProduct: (id: string) => void
}

export const ProjectProductListView = styled((props: ProjectProductListViewProps) => (
  <div className={props.className}>
    {props.productListLabel? (<h3>{props.productListLabel}</h3>) :""}
    <List dense={true}>
      {props.productList.map(p => (
        <ListItem>
          <ListItemText
            primary={p.name}
            secondary={`${p.minPrice} € <-> ${p.maxPrice} €`}
          />
          {props.canDelete === "true" ? (<ListItemSecondaryAction>
            <IconButton onClick={() => props.onDeleteProduct(p.id)} edge="end" aria-label="delete">
              <DeleteIcon/>
            </IconButton>
          </ListItemSecondaryAction>) : '' }

        </ListItem>
      ))}
    </List>
    <ListItem>
      <ListItemText
        primary={props.totalLabel}
        secondary={`${props.productList.reduce((acc, p) => {
          return acc + Number(p.minPrice)
        }, 0)} € <-> ${props.productList.reduce((acc, p) => {
          return acc + Number(p.maxPrice)
        }, 0)} €`}
      />
    </ListItem>


  </div>
))`
  & {
    .bt-project-select {
      width: 100%;
    }
  }`
